export  class ONLWalletSession
{
  result!: string;
  message!: string;
  walletRole!: string;
  walletID!: string;
  onlStartWalletSession!: ONLStartWalletSession;

}
export  class ONLWalletSessionResponse
{
  result!: string;
  message!: string;
  walletRole!: string;
  walletID!: string;
  onlStartWalletSession!: ONLStartWalletSession;
  ibJWT!:string;
  dpatJWT!:string;
}
export  class ONLWalletSessionRequest
{
  sessionId:string='';
}
export class ONLStartWalletSession
{
     action!: string;
     navigatingSystem!: string;
     navigatingSystemRole!: string;
     productSystem!: string;
     productSystemIdentifier1!: string;
     productSystemIdentifier1Name!: string;
     productSystemIdentifier2!: string;
     productSystemIdentifier2Name!: string;
     productType?:string;
     billingType?:string;
     country!: string;
     locale!: string;
     userIdentifier1Name!: string;
     userIdentifier1!: string;
     displayName?:string;
     userEmail!: string;
     callBackURL!: string;
     returnURL?:string;
     objectUID?:string;
     sessionID?:string;
     billingSystem?:string;
     payorID?:string;
     sid?:string;
}


export  class PPIWalletSession
{
  result!: string;
  message!: string;
  walletRole!: string;
  walletID!: string;
  onlStartWalletSession!: ONLStartWalletSession;

}
export  class PPIWalletSessionResponse
{
  result!: string;
  message!: string;
  walletRole!: string;
  walletID!: string;
  onlStartWalletSession!: ONLStartWalletSession;
  ibJWT!:string;
  dpatJWT!:string;
}
export  class PPIWalletSessionRequest
{
  sessionId:string='';
  secret:string='';
  user:string='';
  pass:string='';

}
export class PPIStartWalletSession
{
     action!: string;
     navigatingSystem!: string;
     navigatingSystemRole!: string;
     productSystem!: string;
     productSystemIdentifier1!: string;
     productSystemIdentifier1Name!: string;
     userIdentifier1!: string;
     userIdentifier1Name!: string;
     displayName?:string;
     userEmail!: string;
     callBackURL!: string;
}

export class  DWDPATSessionModel
{
  action: string=' ';
  paymentDirection: string=' ';
  navigatingSystem: string=' ';
  country: string=' ';
  walletID: string=' ';
  locale: string=' ';
  callBackURL: string=' ';
  cashBalance: string=' ';
  rewardsBalance: string=' ';
  createdByUserId: string ='';
  sessionID:string='';
  billingSystem:string='';
  payorID:string='';
  userEmail!: string;
  rewardsEligible!:boolean;
}

export class sessionResponse
{
  url:string='';
}
export class AuthToken
{
  success:boolean=false;
  token:string='';
}
